<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Trustees</h3>

      <!-- Do you want to change any trustees? -->
      <TrusteesYN v-model="form.trusteesYN"/>
      <Trustees v-if="form.trusteesYN" v-model="form.trustees"/>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import TrusteesYN from "@/components/common/questionnaires/question/questions/amendment/TrusteesYN.vue";
import Trustees from "@/components/common/questionnaires/question/questions/amendment/Trustees.vue";

export default {
  name: 'TrusteesAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    TrusteesYN,
    Trustees,
  },
  data() {
    return {
      label: 'Trustees', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
